module.exports = __webpack_public_path__ + "static/media/kast.56ff3d64.png";